import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

interface MileageRangeSelectorAlertProps {
  lowerMiles: number | null;
  upperMiles: number | null;
}

export const MileageRangeSelectorAlert = ({
  lowerMiles,
  upperMiles,
}: MileageRangeSelectorAlertProps) => {
  const lower = lowerMiles ? Number(lowerMiles) : null;
  const upper = upperMiles ? Number(upperMiles) : null;

  const scopeDescription = (() => {
    const hasLower = lower && !isNaN(lower);
    const hasUpper = upper && !isNaN(upper);
    if (hasLower && hasUpper) {
      return (
        <>
          between <strong>{lower}</strong> and <strong>{upper}</strong> miles
        </>
      );
    }
    if (hasLower) {
      return (
        <>
          at least <strong>{lower}</strong> miles
        </>
      );
    }
    if (hasUpper) {
      return (
        <>
          under <strong>{upper}</strong> miles
        </>
      );
    }
    return null;
  })();

  if (!scopeDescription) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      data-testid="mileage-range-selector-warning"
      className="mt-3 flex gap-2 rounded-md border border-yellow-400 bg-yellow-100 p-3"
    >
      <ExclamationTriangleIcon
        className="mt-0.5 h-4 w-4 flex-shrink-0 text-yellow-600"
        aria-hidden="true"
      />
      <p className="text-sm text-yellow-800">
        This pricing model will <strong>only</strong> apply to trips{' '}
        {scopeDescription}. Trips outside this range won't be priced by this
        model.
      </p>
    </div>
  );
};
